import { ENV_URL } from 'constants/env';
import { REQUEST_METHODS } from 'constants/api';
import { NOTIFICATION_TYPES } from 'constants/notificationTypes';
import { LOCAL_STORAGE_KEY } from 'constants/localStorage';
import { getApiErrorMessage } from 'helper/getApiErrorMessage';
import { addNotification } from 'helper/notifications';
import { baseApi } from 'store/baseApi';

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getInvitationInfo: build.query({
      query: ({ invitationId }) => ({ url: `/userprofile/invitations/${invitationId}/` }),
      extraOptions: { isPublic: true },
    }),
    getInvitationUserInfo: build.query({
      query: ({ invitationId }) => ({
        url: `/userprofile/invitations/${invitationId}/check-user-existence-by-invite-link/`,
      }),
      extraOptions: { isPublic: true },
    }),
    login: build.mutation({
      query: (data) => ({
        url: '/userprofile/auth/',
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      extraOptions: { isPublic: true },
    }),
    loginBySso: build.mutation({
      query: ({ data }) => ({
        url: `${ENV_URL}/auth/saml2/check/`,
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      extraOptions: { isPublic: true },
      onQueryStarted: async ({ fromLocation }, api) => {
        try {
          const response = await api.queryFulfilled;

          if (response.data?.token) {
            localStorage.setItem(LOCAL_STORAGE_KEY.FROM_LOCATION, JSON.stringify(fromLocation));
            window.location.href = `${ENV_URL}/auth/saml2/sp/?token=${response.data.token}`;
          }
        } catch {
          // the failure is surfaced by the form through the mutation's error state
        }
      },
    }),
    registerUser: build.mutation({
      query: ({ invitationId, ...data }) => ({
        url: `/userprofile/register/${invitationId}/`,
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      extraOptions: { isPublic: true },
    }),
    resetPassword: build.mutation({
      query: (data) => ({
        url: '/userprofile/reset-password/',
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      extraOptions: { isPublic: true },
      onQueryStarted: async (arg, api) => {
        try {
          const { data } = await api.queryFulfilled;

          addNotification(data.detail, NOTIFICATION_TYPES.SUCCESS);
        } catch (error) {
          addNotification(getApiErrorMessage(error.error));
        }
      },
    }),
    confirmNewPassword: build.mutation({
      query: (data) => ({
        url: '/userprofile/reset-password/confirm/',
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      extraOptions: { isPublic: true },
    }),
    refreshToken: build.mutation({
      query: (data) => ({
        url: '/userprofile/token/refresh/',
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      extraOptions: { isPublic: true },
    }),
  }),
});

export const {
  useGetInvitationInfoQuery,
  useGetInvitationUserInfoQuery,
  useLoginMutation,
  useLoginBySsoMutation,
  useRegisterUserMutation,
  useResetPasswordMutation,
  useConfirmNewPasswordMutation,
} = authApi;
